export default __webpack_public_path__ + "static/intro-dd19ea6ce81801db72115f32bd0f8ee4.png";